import {
  AppstoreOutline,
  ArrowLeftOutline,
  BarsOutline,
  CalendarOutline,
  CheckCircleOutline,
  ClockCircleOutline,
  CloseCircleOutline,
  DeleteOutline,
  DeploymentUnitOutline,
  DownOutline,
  DownloadOutline,
  EditOutline,
  EllipsisOutline,
  ExperimentOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FileSearchOutline,
  FileTextOutline,
  FilterOutline,
  HeartOutline,
  HomeOutline,
  InboxOutline,
  LoadingOutline,
  LockOutline,
  LogoutOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  PictureOutline,
  PlusOutline,
  ProfileOutline,
  SaveOutline,
  SearchOutline,
  ShoppingOutline,
  SkinOutline,
  SwapOutline,
  SyncOutline,
  TagOutline,
  TeamOutline,
  UndoOutline,
  UserOutline
} from '@ant-design/icons-angular/icons';

export const icons = [
  AppstoreOutline,
  ArrowLeftOutline,
  BarsOutline,
  CalendarOutline,
  CheckCircleOutline,
  ClockCircleOutline,
  CloseCircleOutline,
  DeleteOutline,
  DeploymentUnitOutline,
  DownOutline,
  DownloadOutline,
  EditOutline,
  EllipsisOutline,
  ExperimentOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FileSearchOutline,
  FileTextOutline,
  FilterOutline,
  HeartOutline,
  HomeOutline,
  InboxOutline,
  LoadingOutline,
  LockOutline,
  LogoutOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  PictureOutline,
  PlusOutline,
  ProfileOutline,
  SaveOutline,
  SearchOutline,
  ShoppingOutline,
  SkinOutline,
  SwapOutline,
  SyncOutline,
  TagOutline,
  TeamOutline,
  UndoOutline,
  UserOutline,
];
